module.exports = __webpack_public_path__ + "img/产品与服务.fc27d92b.jpg";